import {ListItemTrailingBadge} from '@github-ui/list-view/ListItemTrailingBadge'
import {ActionList, ActionMenu, Button, Tooltip} from '@primer/react'

import {TEST_IDS} from '../constants/test-ids'
import type {IssueFieldBadge} from './IssueFieldPills'
import {IssueFieldValueToken} from './IssueFieldValueBadge'
import styles from './MetadataOverflowMenu.module.css'

type MetadataOverflowMenuProps = {
  hiddenFieldCount: number
  fields: IssueFieldBadge[]
  getIssueFieldHref?: (fieldName: string, queryValue: string) => string
}

// `+N` pill that opens an accessible Primer ActionMenu listing all of the issue's field
// values. Labels are never collapsed in the issues index, so this overflow is fields-only.
// Display + filter only: selecting a value navigates to the filtered list, mirroring a click
// on an inline field pill.
export function MetadataOverflowMenu({hiddenFieldCount, fields, getIssueFieldHref}: MetadataOverflowMenuProps) {
  if (hiddenFieldCount <= 0 || fields.length === 0) return null

  const description = 'Show all'

  return (
    <ListItemTrailingBadge title={description}>
      <ActionMenu>
        <ActionMenu.Anchor>
          <Tooltip direction="nw" text={description}>
            <Button variant="invisible" size="small" className={styles.overflowButton}>
              {`+${hiddenFieldCount}`}
            </Button>
          </Tooltip>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay align="end">
          <ActionList className={styles.overflowList} data-testid={TEST_IDS.listRowMetadataOverflowMenu}>
            {fields.map(field => (
              <ActionList.LinkItem
                key={`overflow-field-${field.fieldName}-${field.displayValue}`}
                href={getIssueFieldHref?.(field.fieldName, field.queryValue)}
              >
                <span className={styles.fieldItem}>
                  <span className={styles.fieldName}>{field.fieldName}</span>
                  <IssueFieldValueToken displayValue={field.displayValue} />
                </span>
              </ActionList.LinkItem>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </ListItemTrailingBadge>
  )
}
